var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"home-view",attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"4"}},[_c('eicrapro-launch-card')],1),_c('v-col',{attrs:{"cols":"8"}},[_c('uyap-status-card',{staticClass:"fill-height"})],1),_c('v-col',{attrs:{"cols":"12"}},[_c('usage-guide-card')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }